{
	"submitTitle": "Seleziona materiale",
	"summary": {
		"title": "Riepilogo",
		"declarationTypeTitle": "Tipo di dichiarazione",
		"projectReferenceTitle": "Riferimento del progetto"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Seleziona il tipo di dichiarazione",
			"customerProject": {
				"title": "Progetto del cliente",
				"description": "Il materiale è stato utilizzato per un progetto esterno. Ora devo fornire una dichiarazione che descriva in dettaglio le riduzioni di carbonio per il mio cliente."
			},
			"internalProjectOrProduct": {
				"title": "Progetto / prodotto interno",
				"description": "Il materiale è stato utilizzato per un progetto o un prodotto interno. Devo creare una dichiarazione per rivendicare le riduzioni di carbonio per le nostre attività."
			}
		},
		"addProjectReferenceSection": {
			"title": "Aggiungi riferimento del progetto",
			"subTitle": "Devi assegnare le riduzioni di carbonio a un riferimento del progetto per cui desideri creare la dichiarazione.",
			"projectReferencePlaceholder": "Riferimento del progetto"
		},
		"selectProjectSection": {
			"title": "Seleziona un progetto",
			"createNewProjectPlaceholder": "Crea nuovo progetto"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Il tipo di dichiarazione è obbligatorio",
		"projectReferenceRequired": "Il riferimento del progetto è obbligatorio",
		"fetchProjectsError": "Impossibile recuperare i progetti precedenti"
	}
}
